export default __webpack_public_path__ + "static/stadium_badge-6de5d433551c40360a64638280d8cb74.svg";